import React, { Component } from "react";
import actions from '../actions';
import { connect } from 'react-redux';
import ObjectUtils from '../../shared/utils/ObjectUtils';
import EntityInterfacesPage from "../components/EntityInterfacesPage";
import PropTypes from "prop-types";
import interfaceActions from "../../interfaces/actions";

class EntityInterfacesPageContainer extends Component {
    constructor() {
        super();
        this.state = {
            universalSearchField: "",
            searchFieldsValues: {
                name: {
                    value: ""
                },
                category: {
                    value: ""
                }
            }
        }
    }

    componentDidMount() {
        const {
            getCategoryList
        } = this.props;

        getCategoryList();

        this.fetchData();
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        const {
            searchFieldsValues,
            universalSearchField
        } = this.state;

        const {
            entityId,
        } = this.props;

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                { ...acc } : { ...acc, [keyValuePair[0]]: keyValuePair[1].value }
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }

        this.props.searchEntityInterfaces( entityId, {
            ...filter,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: sortProperty,
            sortDirection: sortDirection,
        } )
    };

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    };

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    };

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    };

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    };

    onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    };

    handleSortChanged = newSort => {
        const {
            table: {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc ? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    };

    handleRowClicked = entityInterfaceInstance => {
        const { entityId } = this.props;
        this.props.history.push('/entities/' + entityId + '/entityInterfaces/' + entityInterfaceInstance.id);
    };

    render() {
        const { searchFieldsValues, universalSearchField } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            suppressSearchForm,
            externalPageSize,
            categoryList
        } = this.props;

        const definitePageSize = externalPageSize ? externalPageSize : pageSize;
        
        return (
            <EntityInterfacesPage
                searchFieldsValues={searchFieldsValues}
                universalSearchField={universalSearchField}

                handleSearchFieldChange={this.handleSearchFieldChange}
                handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                handleSortChanged={this.handleSortChanged}

                data={data}
                sort={sort}
                totalElements={totalElements}
                pages={pages}
                currentPage={currentPage}
                pageSize={definitePageSize}
                onRowClick={this.handleRowClicked}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}

                categoryList={categoryList}
                suppressSearchForm={suppressSearchForm}
            />
        );
    }
}

const mapStateToProps = ({ interfacesReducer, entityInterfacesReducer }) => {
    return {
        searchFieldsData: entityInterfacesReducer.searchFieldsData,
        table: entityInterfacesReducer.table,
        categoryList: interfacesReducer.categoryList,
    };
};

const mapDispatchToProps = {
    getCategoryList: interfaceActions.getCategoryList,
    searchEntityInterfaces: actions.searchEntityInterfaces,
};

EntityInterfacesPageContainer.propTypes = {
    suppressSearchForm: PropTypes.bool,
    externalPageSize: PropTypes.number,
    entityId: PropTypes.number,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EntityInterfacesPageContainer);